import {Loader} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import ObjednavkaApi from "../api/gen/cgo/ObjednavkaApi";
import {withRouter} from "react-router";
import ObjednavkyUrlFactory from "../api/ObjednavkyUrlFactory";

/**
 * Dummy stránka která pomocí GUID získá ID objednávky a následně přesměruje uživatele na její detail.
 * Pozor, na této stránce nemusí být (a většinou nebude) uživatel přihlášen, takže může volat pouze anonymně dostupné API!
 */
class ObjednavkaGuidPage extends Component {

    componentDidMount() {
        const {guid} = this.props.match.params;
        ObjednavkaApi.getObjednavkaByGuid(guid).then(objednavka => {
            this.props.history.push(ObjednavkyUrlFactory.objednavkaDetail(objednavka.id), {from: this.props.location});
        });
    }

    render() {
        return <Loader/>;
    }
}

export default withRouter(ObjednavkaGuidPage);
